import { render, staticRenderFns } from "./DashCollection.vue?vue&type=template&id=02937304"
import script from "./DashCollection.vue?vue&type=script&lang=js"
export * from "./DashCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports